import { Message } from '@chatscope/chat-ui-kit-react';

const TestMessage = ({ ...props }) => {
    return <Message {...props}></Message>;
};
export default TestMessage;
